import LocalizationDataService from "@/translations/LocalizationDataService";
import { useConfigStore } from "@/store/config"


class ThlSlideMenuService {

    isThemePage(name) {
        const themes = {
            "fi": ["aiheet"],
            "sv": ["teman"],
            "en": ["topics"]
        }
        return themes[LocalizationDataService.getLocale()].includes(name.toLowerCase())
    }

    isTopicPage(name) {
        const pages = {
            "fi": ["thl biopankki","lastensuojelun käsikirja","vammaispalvelujen käsikirja"],
            "sv": ["thl biobank","handbok för barnskyddet","handbok om funktionshinderservice"],
            "en": ["thl biobank","handbook on disability services"]
        }
        return pages[LocalizationDataService.getLocale()].includes(name.toLowerCase())
    }

    isProjectRootPage(name) {
        const store = useConfigStore()
        const pages = store.getProjectRootPages

        return pages[LocalizationDataService.getLocale()].includes(name.toLowerCase())
    }

    useSlideMenu(name) {
        let result = false
        const themes = this.isThemePage(name)
        const topics = this.isTopicPage(name)
        if (themes || topics) result = true
        return result
    }

}

export default new ThlSlideMenuService();